module.exports = __webpack_public_path__ + "static/media/grower-at-pale-green-dots-lower-sheering-farm.crop.5716c9ec.jpg";